export default {
  explanations: [],
  explanation: undefined,
};
